export const selectHairstyleReducer = (state) => state.hairstyles;


